import * as React from "react";
const SvgFiRrProjector = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-projector_svg__a)">
      <path
        fill="#062147"
        d="M19.673 10.045A6.01 6.01 0 0 0 14 6a6.01 6.01 0 0 0-5.657 4H5c-2.757 0-5 2.243-5 5v2a5.01 5.01 0 0 0 3 4.582V23a1 1 0 1 0 2 0v-1h14v1a1 1 0 1 0 2 0v-1.418A5.01 5.01 0 0 0 24 17v-2a5.01 5.01 0 0 0-4.327-4.955M14 8c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m8 9c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3v-2c0-1.654 1.346-3 3-3h3c0 3.309 2.691 6 6 6a6.007 6.007 0 0 0 5.997-5.829A3.005 3.005 0 0 1 22 15zM7 15.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 7 15.5M13 3V1a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0m4.668.445 1-1.5a1 1 0 1 1 1.664 1.11l-1 1.5a1 1 0 0 1-1.387.277 1 1 0 0 1-.277-1.387m-10-.391a1.001 1.001 0 0 1 1.664-1.11l1 1.5a1.001 1.001 0 0 1-1.664 1.11z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-projector_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrProjector;
